export class ShippingTerm {
  id = 0;
  name = "";
  isActive = true;
}
